
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/share/live",
      function () {
        return require("private-next-pages/share/live/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/share/live"])
      });
    }
  